/**
 * Mint a client-side render key for a transcript row.
 *
 * Distinct from a message's `clientMessageId`, which is a durable identity the
 * server echoes back on later snapshots. This one never leaves the browser — it
 * only has to be unique within a session, so a timestamp plus a random suffix
 * is enough and needs no crypto entropy.
 */
export function generateRowId(): string {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}
